import "./ProjectList.scss";

export default function ProjectList({ id, title, active, setselected }) {
  return (
    <li 
      className={active ? "ProjectList active" : "ProjectList"}
      onClick={() => {
        setselected(id);
      }}
    >
      {title}
    </li>
  );
}
